module.exports = __webpack_public_path__ + "img/arrow-right-blue.8a03e410.svg";